'use strict';

var ScrollController = {
		controller: new ScrollMagic.Controller({
			vertical: true
		})
	},
	SubpageNavigation = {
		$items: $('.sp-nav__item'),

		hoveredClass: 'sp-nav__item--hovered',
		dimmedClass: 'sp-nav__item--dimmed',

		initHandler: function initHandler() {
			var _this = this;

			if (w.device.mobile) {
				//No effects on mobile devices
				return;
			}

			this.$items.on('mouseenter',function (e) {
				//Mouse enter
				_this.$items.not(e.currentTarget).addClass(_this.dimmedClass);
				$(e.currentTarget).addClass(_this.hoveredClass);
			}).on('mouseleave',function (e) {
				_this.$items.removeClass([_this.dimmedClass, _this.hoveredClass].join(' '));
			});
		}
	},
	PerformanceCards = {
		$root: $('.sp-graphics__cards, .av-cards'),
		scene: null,
		cardsTimeline: [],
		cardsAnimation: new TimelineMax(),

		selectors: {
			card: '.sp-graphics__card, .av-card',
			cardStatic: '.av-cards-static',
			graph: '.card__graph',
			bar: '.card__graph-bar',
			label: '.card__graph-label',
			heading: '.card__heading',
			perex: '.card__perex'
		},

		vars: function vars() {
			this.$cards = this.$root.find(this.selectors.card);
		},
		initHandler: function initHandler() {
			this.vars();
			this.prepareTimelines();

			this.scene = new ScrollMagic.Scene({
				triggerElement: this.$root[0],
				triggerHook: 0.85,
				reverse: false
			}).setTween(this.cardsAnimation.add(this.cardsTimeline, 0, 'normal', 0.45)).addTo(ScrollController.controller);
		},
		prepareTimelines: function prepareTimelines() {
			var _this2 = this;

			this.$cards.each(function (cardIndex, card) {
				_this2.animateCards($(card), cardIndex);
			});
		},
		animateCards: function animateCards($card, index) {

			this.cardsTimeline[index] = new TimelineMax({ pause: true });
			var $graphContainers = $card.find(this.selectors.graph);
			var $bar = $graphContainers.find(this.selectors.bar);
			var $label = $graphContainers.find(this.selectors.label);
			var $heading = $card.find(this.selectors.heading);
			var $perex = $card.find(this.selectors.perex);
			var animationDuration = 1;

			if (!$card.hasClass('av-card-static')) {
				this.cardsTimeline[index].to($card, animationDuration, { opacity: 1, y: 0, ease: Power3.easeOut });
			}
			this.cardsTimeline[index]
			//.addLabel('animContent')
			.staggerTo($bar, animationDuration, { cycle: { height: [50, 25] }, opacity: 1, ease: Power1.easeOut }, 0.15, 'animContent-=0.8').staggerTo($label, animationDuration, { opacity: 1, ease: Power3.easeOut }, 0.15, 'animContent-=0.8').add(AnimationNumber.create($heading, animationDuration, Power3.easeOut, parseInt($heading.data('number')), '%n'), 'animContent-=0.8').to($perex, animationDuration, { opacity: 1, y: 0, ease: Power3.easeOut }, 'animContent-=0.8');
		}
	},

	$staticPath = document.querySelector('link[href*="v2/avast.css"]').getAttribute('href').split('c/')[0],
	$pathImgAssets = typeof $staticPath !== 'undefined' ? $staticPath : '',

	SubpageAnimationController = {
		animations: {
			malware: AnimationMalware,
			ai: AnimationAi,
			loc: AnimationLocation,
			sec: AnimationSecurity,
			dev: AnimationDevice,
			layers: AnimationLayers
		},

		$header: $('.sp-intro'),
		headerScene: null,
		headerAnimation: null,

		initHandler: function initHandler() {
			var _this3 = this;

			var $svgPlaceholder = this.$header.find('.sp-intro__svg-placeholder');
			var placeholderId = $svgPlaceholder.data('svg');

			if (this.canShowSvgAnimations()) {
				var svg = $pathImgAssets + ('i/mkt/technology/svg/unique/svg-' + placeholderId + '.svg');
				SvgLoader.load(svg, function (svgMarkup) {
					$svgPlaceholder[0].innerHTML = svgMarkup;
					$svgPlaceholder.children().addClass('sp-intro__svg');
					$svgPlaceholder.children().unwrap();

					_this3.headerAnimation = _this3.animations[placeholderId];

					_this3.headerScene = new ScrollMagic.Scene({
						triggerElement: _this3.$header[0],
						triggerHook: 0,
						duration: _this3.$header.outerHeight()
					}).on('enter', function () {
						_this3.headerAnimation.play();
					}).on('leave', function () {
						_this3.headerAnimation.pause();
					}).addTo(ScrollController.controller);
				});
			} else {
				var png = $pathImgAssets + ('i/mkt/technology/svg/raster/svg-' + placeholderId + '__2.png');
				Preload.image({ 0: png }, function (progress, filename) {
					var $img = $('<img class="sp-intro__svg"/>');
					$img[0].src = filename;
					$svgPlaceholder.replaceWith($img);
				});
			}

			//All other svgs
			$('.svg-placeholder').each(function (index, el) {
				var placeholderId = $(el).data('svg');

				if (_this3.canShowSvgAnimations()) {
					var svg = $pathImgAssets + ('i/mkt/technology/svg/unique/svg-' + placeholderId + '.svg');
					SvgLoader.load(svg, function (svgMarkup) {
						el.outerHTML = svgMarkup;
						_this3.animations[placeholderId].play();
					});
				} else {
					var png = $pathImgAssets + ('i/mkt/technology/svg/raster/svg-' + placeholderId + '__2.png');
					Preload.image({ 0: png }, function (progress, filename) {
						var $img = $('<img/>');
						$img[0].src = filename;
						$(el).replaceWith($img);
					});
				}
			});
		},
		resizeEndHandler: function resizeEndHandler() {
			if (!this.headerScene) {
				return;
			}

			this.headerScene.duration(this.$header.outerHeight());
		},
		canShowSvgAnimations: function canShowSvgAnimations() {
			return !w.device.mobile && w.browser.name !== 'ms msie';
		}
	},
	Subpage = {
		initHandler: function initHandler() {
			if (!storageAvailable('localStorage')) {
				return;
			}

			$('.sp-intro__back').click(function () {
				localStorage.removeItem('avastTechnologyHomepageState');
			});
		}
	};

w.autoHandle(SubpageNavigation);
w.autoHandle(PerformanceCards);
w.autoHandle(SubpageAnimationController);
w.autoHandle(Subpage);
